/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Form, Menu, Table } from 'semantic-ui-react';
import { deleteAsync, getAsync, postAsync, putAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { useTranslation } from 'react-i18next';
import { DataNotFound } from '../../../../components/DataNotFound';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import ReactPaginate from 'react-paginate';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
//import './readPhotoGallery.scss';
import moment from 'moment';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import AdminBanner from '../../../../components/elements/AdminBanner';
import SearchFilters from '../../../../components/elements/SearchFilter';
import Downloadcentermodal from './Downloadcentermodal';
import LoaderModal from '../../../../components/common/LoaderModal';
import { useLocation } from 'react-use';
import { PageHitCountApi } from '../../../../shared/Helper';
import { printTable } from '../../../../utils/tableExportUtils';
const defaultImgSrc = '/img/defaultImg.jpg';

export default function Downloadcenter() {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [values, setValues] = useState({
    title: '',
    // publicationDate: '',
    filmingLocation: '',
    keywords: '',
    link: null,
    userID: 0,
    imageSrc: defaultImgSrc,
  });
  const [apiData, setApiData] = useState([]);
  const [title, setTitle] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [date, setDate] = useState('');
  const [filmingLocation, setFilmingLocation] = useState([]);
  const [file, setFile] = useState(null);
  const [doc, setDoc] = useState('');
  const [inputFile, setinputFile] = useState('');
  const [base64URL, setBase64URL] = useState('');
  const [gridModalcreate, setGridModalcreate] = useState(false);
  const [gridModalupdate, setGridModalupdate] = useState(false);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [next, setNext] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [searchTitle, setSearchTitle] = useState('');
  const [recordID, setRecordID] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const toggleShowCreate = (e) => {
    setGridModalcreate(!gridModalcreate);
    setTitle('');
    setTitleEn('');
    setFile('');
    setDoc('');
    setinputFile('');
    FileInputRef.current.value = '';
  };
  const toggleShowUpdate = () => setGridModalupdate(!gridModalupdate);

  const FileInputRef = useRef();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const epUser = localStorage.getItem('apid');
  const token = localStorage.getItem('token');

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };
  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const pageOptions = {
    pageNo: 1,
    pageSize: 20,
  };

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = '';
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load something...
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  const handleFileInputChange = (e) => {
    const selectedFile = e.target.files[0];
    setinputFile(selectedFile.name?.substring(0, 100));
    const pdfSize = selectedFile.size;
    const extension = selectedFile?.name.split('.')[1];
    if (pdfSize > 5242880) {
      return toast.error(t('File is Too Large system contains only less than 5 MB File.'));
    }
    if (extension == 'pdf') {
      getBase64(selectedFile)
        .then((result) => {
          selectedFile['base64'] = result;
          setBase64URL(result);
          setDoc(result.split(',')[1]);
          setFile(selectedFile);
          toast.success(t('File uploaded successfully.'));
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (FileInputRef.current) {
        FileInputRef.current.value = '';
        setFile('');
        setDoc('');
        setinputFile('');
      }
      toast.error(t('Only PDF file are allowed.'));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let data = {
        dateFrom: dateFrom || null,
        dateTo: dateFrom || null,
        title,
        titleEn,
        link: doc,
        file,
      };

      if (file == '' || titleEn == '' || title == '' || doc == '') {
        toast.error(t(`please fill all fields`));
      } else {
        const response = await postAsync(
          'CMSDownloadCenter/CreateCMSCMSDownloadCenter',
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          },
          'multipart/form-data',
        );

        if (response?.statusCode === 200) {
          toast.success(`${t('Created Successfully')}`);
          setTitle('');
          setTitleEn('');
          setFile('');
          setDoc('');
          setinputFile('');
          getData();
          toggleShowCreate(e);
          setDatanotfound(false);
        }
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const bodyUpdate = {
    title,
    titleEn,
    link: doc,
    file,
  };

  const onUpdate = async (id) => {
    // e.preventDefault();
    if (titleEn == '' || title == '' || doc == '') {
      toast.error(t(`please fill all fields`));
    } else {
      await putAsync(
        'CMSDownloadCenter/UpdateCMSCMSDownloadCenter',
        bodyUpdate,
        {
          id: id,
        },
        'multipart/form-data',
      )
        .then((response) => {
          if (response?.statusCode === 200) {
            toast.success(`${t('Updated Successfully')}`);
            getData();
            navigate('/downloadcenter');
          }
        })
        .catch((err) => {
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const getDataByID = async (id) => {
    try {
      setIsLoading(true);
      const response = await getAsync(`CMSDownloadCenter/GetCMSCMSDownloadCenterById`, {
        id: id,
      });

      if (response?.data && response?.data.length > 0) {
        const data = response?.data[0];
        setIsLoading(false);
        setTitle(data?.title);
        setTitleEn(data?.titleEn);
        setDate(data?.date);
        setDoc(data?.doc);
        setinputFile(data?.fileName);
        toggleShowUpdate();
        toast.info(data?.message);
      }
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const updateRecordById = (e, id) => {
    e.preventDefault();
    getDataByID(id);
    setRecordID(id);
  };

  const showPreview = (e) => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];
      const reader = new FileReader();
      reader.onload = (x) => {
        setValues({
          ...values,
          imageFile,
          imageSrc: x.target.result,
        });
        const base64 = x.target.result.split(',').splice(1, 1)[0];
        //console.log('image', base64);
        setDoc(base64);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setValues({
        ...values,
        imageFile: null,
        imageSrc: defaultImgSrc,
      });
    }
  };

  const getData = async () => {
    setIsLoad(true);
    await postAsync(
      `CMSDownloadCenter/GetCMSDownloadCenterFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
      bodyGet,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response?.page);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
        setNext(pageOptions.pageNo);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
    (async function () {
      try {
        const response = await getAsync('Utilities/GetCountryList');
        setFilmingLocation(response?.data);
      } catch (error) {
        toast.error(t('Something went wrong, Please try again!'));
      }
    })();
  }, []);

  const SearchFilter = {
    // epUserID: epUser,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    cmsTitle: searchTitle,
  };
  const SearchRecord = async () => {
    try {
      setIsLoad(true);
      setDatanotfound(false);
      const response = await postAsync(
        `CMSDownloadCenter/GetCMSDownloadCenterFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
        SearchFilter,
      );
      if (response) {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
      }
      if (response?.statusCode == 204) {
        setDatanotfound(true);
      }
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const onDelete = async (id) => {
    await deleteAsync('CMSDownloadCenter/DeleteCMSDownloadCenter', { id: id })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('Deleted Successfully')}`);
          setApiData(response?.data);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };
  const handleFileDelete = async (e) => {
    e.preventDefault();
    setFile(null);
    setinputFile(null);
    if (FileInputRef.current) {
      FileInputRef.current.value = '';
    }
  };

  const handleFileDownload = async (e, file) => {
    e.preventDefault();
    const fileUrl = URL.createObjectURL(file);
    const downloadLink = document.createElement('a');
    downloadLink.href = fileUrl;
    downloadLink.download = file.name;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(fileUrl);
  };
  const bodyGet = {
    epUserID: epUser,
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    //setPageCount(select);
    await postAsync('CMSPhotoGallery/GetCMSPhotoGalleryFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row className="text-sm" key={index} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{isActive ? data?.title || '' : data?.titleEn || ''}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>

        {/* <Table.Cell>{data?.userID}</Table.Cell> */}
        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
            type="button"
            onClick={(e) => {
              updateRecordById(e, data?.downloadCenterID);
            }}
          >
            {t('Update')}
          </button>
        </Table.Cell>

        <Table.Cell>
          <button
            className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
            onClick={() => onDelete(data.downloadCenterID)}
          >
            {t('delete')}
          </button>
        </Table.Cell>
      </Table.Row>
    );
  });

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      Title: isActive ? item.title : item.titleEn,
      Date: item.date,
    }));
    downloadCSV(filteredData, 'Download_center');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Download Center List')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('cms_title')}</th>

  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`cms_publicationDate`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.title || '' : data?.titleEn || ''}</td>

  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
  const handlePrint = (e) => {
    e.preventDefault();

    // Column configuration
    const columns = [
      {
        header: t('sNo'),
        accessor: (row, index) => index + 1,
      },
      {
        header: t('cms_title'),
        accessor: (row) => (isActive ? row?.title : row?.titleEn),
      },
      {
        header: t('cms_publicationDate'),
        accessor: (row) => (isActive ? row?.date || 'N/A' : row?.date|| 'N/A'),
      },
    ];

    // Call the reusable print function
    printTable({
      data: apiData || [],
      isRTL: isActive, // isActive true = Arabic = RTL
      t: t,
      title: `${t('Download Center List')} `,
      columns: columns,
      onBeforePrint: () => {
        // console.log('Printing started...');
        // toast.info(t('Preparing print preview...'));
      },
      onAfterPrint: () => {
        // console.log('Printing completed');
      },
      styles: {
        customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `,
      },
    });
  };
  return (
    <>
      {!isLogin ? (
        <h1>{t('notAuthorized')}</h1>
      ) : (
        <>
          <div className="container-fluid">
            {/* <div className="row justify-center ">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">
                  {t('Download Center')} {t('list')}
                </h3>
              </div>
            </div> */}

            <div className="row text-center">
              <div className="col-lg-11 flex justify-end my-4">
                <button
                  className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                  onClick={toggleShowCreate}
                >
                  {t('create')}
                </button>
              </div>
            </div>

            <div className="row justify-center flex-row">
              <SearchFilters
                handleSearch={SearchRecord}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Download Center List'}
                isTitleVisible={true}
                setSearchTitle={setSearchTitle}
                isApplicantName={false}
              />
            </div>

            {/* Modal Create */}
            <>
              <MDBModal tabIndex="-1" show={gridModalcreate} setShow={setGridModalcreate}>
                <MDBModalDialog className="flex justify-center items-center">
                  <MDBModalContent className="w-auto bg-green-50 sm:w-[50vw] md:w-[80vw] lg:w-[100vw]">
                    <Form className="flex sm:max-w-[50vw] md:max-w-[60vw] lg:w-[60vw]  flex-col justify-center items-center">
                      <MDBModalHeader>
                        <MDBModalTitle className="text-customgreen font-semibold">
                          {t('Create Download Center')}
                        </MDBModalTitle>
                        {/* <MDBBtn type="button" className="btn-close" color="none" onClick={toggleShowCreate}></MDBBtn> */}
                      </MDBModalHeader>
                      <MDBModalBody>
                        <div className="container-fluid bd-example-row">
                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('cms_title')} : </label>
                                <input
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  type="text"
                                  name="title"
                                  value={title}
                                  required
                                  onChange={(e) => setTitle(e.target.value)}
                                  placeholder={t('cms_title')}
                                />
                              </Form.Field>
                            </div>
                            <div className="col-md-6 col-example">
                              <Form.Field>
                                <label className="mx-auto text-customgreen">{t('Title En')} : </label>
                                <input
                                  className="  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  type="text"
                                  value={titleEn}
                                  name="title_En"
                                  required
                                  onChange={(e) => setTitleEn(e.target.value)}
                                  placeholder={t('Title En')}
                                />
                              </Form.Field>
                            </div>
                          </div>

                          <div className="row" style={{ marginBottom: '10px' }}>
                            <div className="col-md-12 col-example">
                              <Form.Field>
                                <label className="mx-auto  text-customgreen">
                                  {t('Documents upload')}{' '}
                                  <span className="text-red-700 ">{t('(Upload PDF File)')}</span>
                                </label>
                                <input
                                  className="mb-3  border w-full border-gray-300 text-customgreen text-sm rounded-lg focus:ring-customgreen focus:border-customgreen  "
                                  onChange={handleFileInputChange}
                                  type="file"
                                  accept=".pdf"
                                  ref={FileInputRef}
                                />
                              </Form.Field>

                              <div className="row mt-3">
                                <div className="col-lg-12">
                                  {file && (
                                    <Table className="text-sm text-left rtl:text-right ">
                                      <Table.Header className="text-xs text-white bg-customgreen uppercase  ">
                                        <Table.Row>
                                          <Table.Cell className="text-white">{t('sNo')}</Table.Cell>
                                          <Table.Cell className="text-white">{t('File')}</Table.Cell>
                                          <Table.Cell className="text-white">{t('Action')}</Table.Cell>
                                        </Table.Row>
                                      </Table.Header>
                                      <Table.Body>
                                        <Table.Row>
                                          <Table.Cell>1</Table.Cell>
                                          <Table.Cell>
                                            {/* {!allowedFileExtensions.includes(FileCheck) ||
                                        inputFileSize > 1097152 ? (
                                          <label
                                            style={{
                                              color: 'red',
                                              fontWeight: '500'
                                            }}>
                                            Uploaded File must contain these formats [jpg, png,
                                            jpeg, pdf]and must not be greater than 2 MBs.
                                            {inputFileSize} -- {FileCheck}
                                          </label>
                                        ) : ( */}
                                            <label>{inputFile}</label>
                                            {/* )} */}
                                          </Table.Cell>
                                          <Table.Cell>
                                            <button
                                              className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen  font-medium rounded-full text-sm px-3 py-2.5 text-center"
                                              onClick={(e) => handleFileDownload(e, file)}
                                              style={{
                                                margin: '5px',
                                              }}
                                            >
                                              <FileDownloadOutlinedIcon />
                                            </button>{' '}
                                            <button
                                              className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen font-medium rounded-full text-sm px-3 py-2.5 text-center"
                                              style={{
                                                margin: '5px',
                                              }}
                                              onClick={(e) => handleFileDelete(e)}
                                            >
                                              {t('Delete')}
                                              {/* <DeleteOutlinedIcon /> */}
                                            </button>
                                          </Table.Cell>
                                        </Table.Row>
                                      </Table.Body>
                                    </Table>
                                  )}
                                </div>
                              </div>

                              {/* <img style={{ height: '120px', width: '150px' }} src={values.imageSrc} className="card-img-top" /> */}
                            </div>
                          </div>
                        </div>
                      </MDBModalBody>
                      <MDBModalFooter className="flex justify-center">
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center "
                          onClick={(e) => {
                            handleSubmit(e);
                          }}
                        >
                          {t('create')}
                        </button>
                        <button
                          className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none  font-medium rounded-full text-sm px-5 py-2 text-center"
                          onClick={toggleShowCreate}
                          type="button"
                        >
                          {t('close')}
                        </button>
                      </MDBModalFooter>
                    </Form>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </>
            {/* end */}
            {/* Modal Update */}
            <>
              <Downloadcentermodal
                t={t}
                gridModalupdate={gridModalupdate}
                setGridModalupdate={setGridModalupdate}
                recordID={recordID}
                title={title}
                setTitle={setTitle}
                titleEn={titleEn}
                setTitleEn={setTitleEn}
                showPreview={showPreview}
                onUpdate={onUpdate}
                onChange={handleFileInputChange}
                handleFileDownload={handleFileDownload}
                handleFileDelete={handleFileDelete}
                inputFile={inputFile}
                file={file}
                doc={doc}
                FileInputRef={FileInputRef}
              />
            </>
            {/* end */}
            <div className="row justify-center pb-5 ">
              {isLoad ? (
                <LoadingAnimation />
              ) : (
                <div className="col-lg-11 text-center pt-9">
                  <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
                    <Table className="text-sm tableData text-left rtl:text-right ">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase ">
                        <Table.Row>
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('cms_title')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Date')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body className="tableData">{displayRecords}</Table.Body>
                    </Table>
                    {datanotfound && <DataNotFound />}
                  </div>

                  {pageCount > 0 && (
                    <div className="flex flex-row px-12 justify-between">
                      <Menu pagination>
                        <Menu.Item>
                          <ReactPaginate
                            previousLabel={t('Previous')}
                            nextLabel={t('Next')}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={'paginationButtons'}
                            previousLinkClassName={'previousButton'}
                            nextLinkClassName={'nextButton'}
                            disabledClassName={'paginationDisabled'}
                            activeClassName={'paginationActive'}
                          />
                        </Menu.Item>
                      </Menu>
                    </div>
                  )}
                </div>
              )}
              {isLoading && <LoaderModal />}
            </div>
          </div>
        </>
      )}
    </>
  );
}
